import { uniqueNonEmpty } from "utils/dataManipulation";

import type { EpcExtractionData } from "../components/address-step/epc-modal/types";

import { geocodeAddressWithFallback } from "../api/geocoding";
import { buildGeocodingQueryCandidates } from "../components/address-step/lib/addressHelpers";

const buildEpcGeocodingQueryCandidates = (epcData: EpcExtractionData) => {
  const suggested = epcData.suggestedFields;
  const locationParts = {
    city: suggested?.city,
    country: suggested?.country,
    postal_code: suggested?.postCode,
  };

  const streetCandidates = suggested?.street
    ? buildGeocodingQueryCandidates({ ...locationParts, address: suggested.street })
    : [];

  const fullAddress = suggested?.address ?? epcData.page1?.building?.address ?? undefined;
  const fullAddressCandidates = fullAddress ? buildGeocodingQueryCandidates({ address: fullAddress }) : [];

  const queries = uniqueNonEmpty([...streetCandidates, ...fullAddressCandidates]);
  return queries;
};

export const geocodeEpcExtractionAddress = async (epcData: EpcExtractionData, signal?: AbortSignal) => {
  const queries = buildEpcGeocodingQueryCandidates(epcData);
  if (!queries.length) return null;
  return geocodeAddressWithFallback(queries, signal);
};

export const enrichEpcExtractionWithGeocodedCountry = (
  epcData: EpcExtractionData,
  country: string | undefined
): EpcExtractionData => {
  if (!country) return epcData;

  return {
    ...epcData,
    suggestedFields: {
      ...epcData.suggestedFields,
      country,
    },
  };
};
